import { Divider } from '@material-ui/core';
import React from 'react';
import { Link } from "react-router-dom"; 


export default function MasterUserAllDetails(rowData) {
    const userDetails = rowData.location.state
    // console.log(userDetails, "userdetails")
    if (userDetails) {
        return (
            <>
                <div className="card card-custom card-sticky" id="kt_page_sticky_card">
                    <div className="card-header ">
                        <div className="card-title">
                            <div className="card-label">
                                <small>Details of</small> <h3 className="text-secondary ">  {(userDetails.vFullName)}</h3>
                            </div>
                        </div>
                        <div className="card-toolbar ">
                            <Link to={ "/master-user"} className="btn btn-light-primary font-weight-bolder mr-2">
                                <i className="ki ki-long-arrow-back icon-sm"></i>
                                Return to list
                            </Link> </div>
                    </div>
                </div>

                <div className="card card-body">
                    <div className="form-group row">
                        <div className="col-lg-4">
                            <label className="">Id</label>
                            <h5 className="text-muted">{(userDetails._id)}</h5>
                        </div>
                        <div className="col-lg-4">
                            <label className="">User Name</label>
                            <h5 className="text-muted">{(userDetails.vUserName)}</h5>
                        </div>
                        <div className="col-lg-4">
                            <label className="">Email</label>
                            <h5 className="text-muted">{(userDetails.vEmail)}</h5>
                        </div>
                    </div>
                    <Divider variant="middle" />
                    <div className="form-group row mt-5">
                        <div className="col-lg-4">
                            <label className="">Phone Number:</label>
                            <h5 className="text-muted">{(userDetails.bPhoneNumber)}</h5>
                        </div>
                        <div className="col-lg-4">
                            {/* <label className="">Full Name:</label>
                            <h5 className="text-muted">{(userDetails.vFullName)}</h5>  */}
                        </div>
                        <div className="col-lg-4">
                            {/* <label className="">Full Name:</label>
                            <h5 className="text-muted">{(userDetails.vFullName)}</h5>  */}
                        </div>
                    </div>
                    <Divider variant="middle" />
                    <div className="form-group row mt-5">
                        <div className="col-lg-4">
                            {/* <label className="">Full Name:</label>
                            <h5 className="text-muted">{(userDetails.vFullName)}</h5>  */}
                        </div>
                    </div>
                    <Divider variant="middle" />
                    <div className="form-group row mt-5">
                        <div className="col-lg-4">
                            {/* <label className="">Full Name:</label>
                            <h5 className="text-muted">{(userDetails.vFullName)}</h5>  */}
                        </div>
                    </div>


                </div>



            </>
        );
    }
    else {
        return (<><div className="card card-custom shadow" id="kt_page_sticky_card">
            <div className="card-header ">
                <div className="card-title">
                    <h4 className="card-label">
                        Select a user from the list
                    {/* <i className="mr-2"></i> */}
                    </h4>
                </div>
                <div className="card-toolbar ">
                    <Link to="/master-user" className="btn btn-light-primary font-weight-bolder mr-2">
                        <i className="ki ki-long-arrow-back icon-sm"></i>
                    Return to list
                </Link> </div>
            </div>
        </div></>)
    }

}
